module.exports = __webpack_public_path__ + "static/media/cao.650162ca.svg";